import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BoothLightboxContext } from 'pages/booths/components/BoothLightboxContext';

import LiveWebinarItem from './LiveWebinarItem';
import OnDemandWebinarItem from './OnDemandWebinarItem';

import { WEBINAR_TYPES } from '../../models/webinars';

const RootContainer = styled.div`
  flex: 1 0 auto;
  max-width: 1000px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 960px) {
    padding: 24px 0;
  }

  @media (max-width: 960px) {
    padding: 0;
  }
`;

const locale = 'en';
const WebinarList = ({ webinars }) => (
  <RootContainer>
    {
      webinars.map(({
        id, kind, startAt, endAt, timezone, speakers, translations,
      }) => {
        switch (kind) {
          case WEBINAR_TYPES.live:
            return (
              <LiveWebinarItem
                key={id}
                id={id}
                name={translations[locale].title}
                startAt={startAt}
                endAt={endAt}
                timezone={timezone}
                details={translations[locale].description}
                url={translations[locale].url}
                cfStreamId={translations[locale].cloudflare_stream_id}
                speakers={speakers}
              />
            );
          case WEBINAR_TYPES.onDemand:
          default:
            return (
              <OnDemandWebinarItem
                key={id}
                id={id}
                name={translations[locale].title}
                details={translations[locale].description}
                url={translations[locale].url}
                // eslint-disable-next-line camelcase
                cfStreamId={translations[locale]?.cloudflare_stream_id}
                speakers={speakers}
              />
            );
        }
      })
    }
  </RootContainer>
);

WebinarList.propTypes = {
  webinars: PropTypes.arrayOf(PropTypes.shape()),
};

WebinarList.defaultProps = {
  webinars: [],
};

export default WebinarList;
